export default class CommentVideoSection {
  static disable() {
    let mobilePremiumComment = document.querySelector('.comment-input-wrapper.premium-comment.hide');
    let desktopPremiumComment = document.querySelector('.comments-form.premium-comment.hide');

    if(mobilePremiumComment) {
      let mobileEnableComment = document.querySelector('.comment-input-wrapper.enable-comment');

      mobilePremiumComment.classList.remove('hide');

      if(mobileEnableComment) {
        mobileEnableComment.remove();
      }
    }

    if(desktopPremiumComment) {
      let desktopEnableComment = document.querySelector('.comments-form.enable-comment');

      desktopPremiumComment.classList.remove('hide');

      if(desktopEnableComment) {
        desktopEnableComment.remove();
      }
    }

    CommentVideoSection.hideReplyButton();
    CommentVideoSection.hideReorderButton();
  }

  static hideReplyButton() {
    let replyButtons = document.querySelectorAll('.comments__actions-reply')
    if (replyButtons) {
      replyButtons.forEach((button) => {
        button.classList.add('hide')
      })
    }

    let commentsMargins = document.querySelectorAll('.comments__actions-margin')
    if (commentsMargins) {
      commentsMargins.forEach((button) => {
        button.classList.remove('hide')
      })
    }
  }

  static hideReorderButton() {
    let reorderCommentButton = document.querySelector('.dropdown__selected--small');
    if (reorderCommentButton) {
      reorderCommentButton.classList.add('hide');
    }
  }
}
